import React, { useState, memo } from "react";
import { useForm  } from "react-hook-form";

import swal from '@sweetalert/with-react';
import InputMask from 'react-input-mask';

import Service from "../services/service";

import { connect } from 'react-redux';
import actions from '../redux/actions';

/*************************************************************************/
/* Esse componente é quando quer pesquisar o CEP */
/*************************************************************************/
const Index = (props) => {

  const { register, watch, setValue, getValues, formState: { errors }} = useForm({
    defaultValues: {
      zipcode: props.initialValue
    }
  });

  const [findMaker, setFindMaker] = useState(false);
  const [findByCep, setFindByCep] = useState(false);

  const getMarker = async () => {

    setFindMaker(true);

    const address = await Service.getMarker();
    const user = Service.parseMarkerAddress(address[0])

    showAddress(user);
    setFindMaker(false);
  }

  const getCepbyGoogle = (cep) => {

    cep = cep.replace(/\D/g, "");
    if (!cep) {      
      return false;
    }

    if(cep.length !== 8){
      swal('Ixi!', 'Digite um cep válido', 'error');
      return false;
    }

    setFindByCep(true);

    Service.googleMaps(cep).then(resp => {

      if(!resp){
        swal('', 'Parece que esse CEP não foi encontrado na base do Google!', 'info');
        return false;
      }

      showAddress(resp);
    }).catch(e => {
      swal('', 'Ocorreu um erro em sua requisição de cep', 'error');
    }).finally(() => {
      setFindByCep(false)
    });
  }

  const showAddress = (resp) => {
    if (!resp) {
      swal('', "Ixe! Cep não encontrado", 'error');
      return false;
    }

    props.onFormatAddress(resp)
  }

  return (
    <div className="form-group mb-3">
      <label className="form-label" htmlFor="cep">Cep:</label>
      <div className="input-group">
        <InputMask
          type="tel"
          id="cep"
          mask="99999-999"
          placeholder="18800-000"
          name="cep"
          required={true}
          className="form-control"
          {...register("zipcode")}
          onChange={(event) => {

              var value = (event.target.value);
              console.log(value);
              if(value.replace(/\D/g, "").length === 8){
                getCepbyGoogle(value);      
              }
            }
          }
          onBlur={() =>
            getCepbyGoogle(watch('zipcode'))
          }
        />
          <button
            type="button"
            onClick={() =>
              getCepbyGoogle(watch('zipcode'))
            }
            className="btn btn-info"
            type="button"
            title="Pesquisar Cep"
          >
            <span hidden={findByCep}>Ok</span>
            <span hidden={!findByCep}>...</span>
          </button>
      </div>
      <small className="form-text text-muted">
        <span hidden={!findMaker}>
          pesquisando...
        </span>
        <button
          type="button"
          hidden={findMaker}
          onClick={() => getMarker(event)}
          className="btn btn-link"
          title="Usar posição atual"
        >
          Não sei meu cep
        </button>
      </small>
    </div>
  )
}

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.authentication.token,
    token: state.authentication.token,
    user: state.authentication.user
  }
);

export default memo(connect(mapStateToProps, actions)(Index));